var exports = {
  "kL": "xcc377c0b--9d4e75--container",
  "HU": "xcc377c0b--9d4e75--aside",
  "VN": "xcc377c0b--9d4e75--close",
};

module.exports = exports;
